module.exports = __webpack_public_path__ + "img/hubspot.2179cfc4.jpg";